import { api } from '@/core/api/';

const apiUrl = 'api/academicyears';

export default {
  getAcademicYears(paramAPI, route, properties) {
    return paramAPI.get(`${apiUrl}/${route}`, {
      params: {
        ...properties,
      },
    });
  },
  getCurrentAcademicYear() {
    return api.get(`${apiUrl}/current`);
  },
  getStudentExitAcademicYears() {
    return this.getAcademicYears(api, 'studentexit');
  },
  getInvoiceYears() {
    return this.getAcademicYears(api, 'invoiceYears');
  },
  getExistingPeisAcademicYears() {
    return this.getAcademicYears(api, 'existingpeis');
  },
  getCurrentYearAcademicYears() {
    return this.getAcademicYears(api, 'academicyearstocurrentyear');
  },
  getMonthsInAcademicYear(academicYearId) {
    return api.get(`${apiUrl}/monthsinyear?academicYearId=${academicYearId}`);
  },
  getAcademicYearsFromSpecificYear(fromAcademicYearId) {
    return api.get(
      `${apiUrl}/academicyearsfromspecificyear/${fromAcademicYearId}`
    );
  },
  getAcademicYearsFromSpecificYearAttendance() {
    return api.get(`${apiUrl}/academicyearsfromspecificyearattendance`);
  },
  getAcademicYearsFromMinType(minYear = 2021, yearType = 'FUTURE') {
    return api.get(`${apiUrl}/academicyearfromintotype`, {
      params: {
        minYear,
        yearType,
      },
    });
  },
  getCalendarYearsFromSpecificYear(fromAcademicYearId) {
    return api.get(
      `${apiUrl}/calendaryearfromspecificyear/${fromAcademicYearId}`
    );
  },
  getCurrentPreviousAcademicYear() {
    return this.getAcademicYears(api, 'currentPreviousYear');
  },
  getAcademicYearsFromToCurrentYear(fromAcademicYearId) {
    return api.get(
      `${apiUrl}/calendaryearfromtocurrentyear/${fromAcademicYearId}`
    );
  },
  getAcademicYearsWithParentInventory() {
    return api.get(`${apiUrl}/parentinventory`);
  },
};
